/**
 * Parking API Help
 * Instructions for finding the parking registration API values
 * (URL, Location ID, Policy ID, Space) from the building's parking portal.
 */

import React from 'react';
import { Alert } from 'react-bootstrap';

const ParkingApiHelp = () => (
  <Alert variant="light" className="border small mb-3">
    <strong><i className="bi bi-info-circle me-1"></i>How to find these values</strong>
    <ol className="mb-2 mt-2">
      <li>Open your building's parking portal (e.g. <em>metro.parkingattendant.com</em>) in a desktop browser</li>
      <li>Open the browser's Developer Tools (<code>F12</code> or right-click → Inspect) and switch to the <strong>Network</strong> tab</li>
      <li>Register a guest permit on the portal as you normally would</li>
      <li>In the Network list, find the request ending in <code>/v1/permits/temporary</code> and click it</li>
      <li>Open its <strong>Payload</strong> / query parameters and copy the values:</li>
    </ol>
    <ul className="mb-0">
      <li><code>location</code> → <strong>Location ID</strong></li>
      <li><code>policy</code> → <strong>Policy ID</strong></li>
      <li><code>space</code> → <strong>Space</strong></li>
      <li><code>tenant</code> / <code>token</code> → <strong>Tenant</strong> / <strong>Token</strong> fields below</li>
      <li>The request's URL (the part before the <code>?</code>) → <strong>Registration API URL</strong></li>
      <li>The portal's address bar URL (e.g. <code>https://yourbuilding.parkingattendant.com</code>) → <strong>Portal URL</strong> field below</li>
    </ul>
    <div className="mt-2">
      If the request also has <code>name</code>, <code>email</code>, or <code>notes</code> parameters, add them as
      key-value pairs too — some policies require them (the API will say exactly which one is missing).
    </div>
    <div className="mt-2">
      <i className="bi bi-lightbulb me-1"></i>
      Leave any field empty to use your building's default (set by whoever runs this server).
    </div>
  </Alert>
);

export default ParkingApiHelp;
